import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Card, Form, Button, Row, Col } from "react-bootstrap";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Select from "react-select";
import { ring } from 'ldrs';
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import {decryptData } from "../../../Auth/cryptage";

function CreateUser() {
    const [formValues, setFormValues] = useState({
        name: '',
        prenom: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone: '',
        roles: []
    });
    const [roles, setRoles] = useState([]);
    const [options, setOptions] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState({
        who: '',
        status: false
    });
    ring.register();
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSelectChange = (selectedOptions) => {
        setFormValues({ ...formValues, roles: selectedOptions });
    };

    const validateForm = () => {
        const errors = {};

        if (!formValues.name) {
            errors.name = "Nom is required";
        }
        if (!formValues.prenom) {
            errors.prenom = "Prénom is required";
        }
        if (!formValues.email) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
            errors.email = "Email is invalid";
        }
        if (!formValues.password) {
            errors.password = "Password is required";
        }
        if (!formValues.password_confirmation) {
            errors.password_confirmation = "Password confirmation is required";
        } else if (formValues.password !== formValues.password_confirmation) {
            errors.password_confirmation = "Passwords do not match";
        }
        if (!formValues.phone) {
            errors.phone = "Phone is required";
        } else if (!/^\d+$/.test(formValues.phone)) {
            errors.phone = "Phone must be a number";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const getRolesData = async () => {
        try {
            setLoading({
                who: 'roles',
                status: true,
            });
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/roles', {
                headers: {
                    'X-Custom-Token': token
                }
            });
            
            if(!result.data.roles){
                setRoles([]);
            }else{
                setRoles(result.data.roles);
            }
        } catch (error) {
            console.error("Error fetching roles: ", error);
            MySwal.fire({ title: "Error!", text: 'Error fetching roles.', icon: "error" });
        } finally {
            setLoading({
                who: 'roles',
                status: false,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading({
                who: 'submit',
                status: true,
            });
            try {
                const token = decryptData(Cookies.get('access_token'));
                const formData = {
                    ...formValues,
                    roles: formValues.roles.map(role => role.value)
                };
                await axios.post('https://ai.api.gecimmo.xyz/AI-GECIMMO/public/api/admin/user/store', formData, {
                    headers: {
                        'X-Custom-Token': token
                    }
                });
                MySwal.fire({ title: "Succès!", text: 'Utilisateur créé avec succès.', icon: "success" });
                navigate("/dashboard/users");
                setFormValues({
                    name: '',
                    prenom: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    phone: '',
                    roles: []
                });
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    // console.log()('Validation Errors:', error.response.data.errors);
                    MySwal.fire({ title: "Error!", text: 'Validation failed. Please check the form inputs.', icon: "error" });
                } else {
                    MySwal.fire({ title: "Error!", text: error.message, icon: "error" });
                }
            } finally {
                setLoading({
                    who: 'submit',
                    status: false
                });
            }
        }
    };

    useEffect(() => {
        getRolesData();
    }, []);

    useEffect(() => {
        setOptions(roles.map((role) => ({
            value: role.id,
            label: `${role.name}`
        })));
    }, [roles]);
    useEffect(() => {
        document.title = "GecimmoIA - Ajouter un utilisateur";
    }, []);
    const back = () => {
        navigate(-1);
    };
    return (
        <Container fluid className="d-flex align-items-center justify-content-center mt-5">
            <Card className="adminCards w-75">
                <Card.Body className="px-5">
                    <h2 className="text-center mb-5">Créer un utilisateur</h2>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="name">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        size="lg"
                                        value={formValues.name}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.name}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="prenom">
                                    <Form.Label>Prénom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="prenom"
                                        size="lg"
                                        value={formValues.prenom}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.prenom}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.prenom}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="phone">
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="phone"
                                        size="lg"
                                        value={formValues.phone}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.phone}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.phone}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        size="lg"
                                        value={formValues.email}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col>
                                <Form.Group className="text-center" controlId="roles">
                                    <Form.Label>Les rôles</Form.Label>
                                    <Select
                                        name="roles"
                                        options={options}
                                        isMulti
                                        value={formValues.roles}
                                        onChange={handleSelectChange}
                                        placeholder={
                                            loading.status && loading.who === "roles" ? (
                                                <l-ring
                                                    size="30"
                                                    stroke="3"
                                                    bg-opacity="0"
                                                    speed="2"
                                                    color="black"
                                                />
                                            ) : "Choisissez les rôles"
                                        }
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="password">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        size="lg"
                                        value={formValues.password}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.password}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.password}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="password_confirmation">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password_confirmation"
                                        size="lg"
                                        value={formValues.password_confirmation}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.password_confirmation}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.password_confirmation}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button
                            disabled={loading.status && loading.who === "submit"}
                            type="submit"
                            className="mb-4 w-100"
                            size="lg"
                        >
                            {loading.status && loading.who === "submit" ? (
                                <l-ring size="30" stroke="3" bg-opacity="0" speed="2" color="white" />
                            ) : "Enregistrer"}
                        </Button>
                        <Button className="backbtn mb-4 w-100" onClick={back} size="lg">
                            <BsArrowLeft className="btnbackIcon" />
                            Back
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default CreateUser;
